import { render, staticRenderFns } from "./orderDetail_view.vue?vue&type=template&id=2f9f32b7&scoped=true&"
import script from "./orderDetail_view.vue?vue&type=script&lang=js&"
export * from "./orderDetail_view.vue?vue&type=script&lang=js&"
import style0 from "./orderDetail_view.vue?vue&type=style&index=0&id=2f9f32b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9f32b7",
  null
  
)

export default component.exports